// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardListInChat_newChatText__GosZr {
    color: #616161;
    text-align: center;

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    /* 142.857% */
}

.DashboardListInChat_cardContainer__CGpqq {
    margin: 0;
    position: relative;
}
.DashboardListInChat_cardContainer__CGpqq > div{
    margin: 0 auto;
}
/* helper to ensure cards row wraps and centers content */
.DashboardListInChat_cardsRow__abNGI {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;
    /* align-items: stretch; */
}`, "",{"version":3,"sources":["webpack://./src/Common/Components/DashboardListInChat/DashboardListInChat.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kBAAkB;;IAElB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA,yDAAyD;AACzD;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,0BAA0B;AAC9B","sourcesContent":[".newChatText {\n    color: #616161;\n    text-align: center;\n\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    /* 142.857% */\n}\n\n.cardContainer {\n    margin: 0;\n    position: relative;\n}\n.cardContainer > div{\n    margin: 0 auto;\n}\n/* helper to ensure cards row wraps and centers content */\n.cardsRow {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    justify-content: center;\n    /* align-items: stretch; */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newChatText": `DashboardListInChat_newChatText__GosZr`,
	"cardContainer": `DashboardListInChat_cardContainer__CGpqq`,
	"cardsRow": `DashboardListInChat_cardsRow__abNGI`
};
export default ___CSS_LOADER_EXPORT___;
